// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"cartSyncStatus_is-mob__tWsTN","is-desk":"cartSyncStatus_is-desk__2PZKC","status":"cartSyncStatus_status__xJMtG"};